export default class Contrato{
    constructor(obj){
        this._CeclamNcm = obj._CeclamNcm
        this._CeclamEmenta =  obj._CeclamEmenta;
        this._CeclamExcecao =obj._CeclamExcecao;
        this._CeclamLegislacao =  obj._CeclamLegislacao
    }

    get CeclamNcm(){
        return this._CeclamNcm;
    }
    get CeclamEmenta(){
        return this._CeclamEmenta;
    }
    get CeclamEmentaNcm(){
        return this._CeclamEmentaNcm;
    }
    get CeclamEmentaExcecao(){
        return this._CeclamEmentaExcecao;
    }
    get CeclamExcecao(){
        return this._CeclamExcecao;
    }
    get CeclamLegislacao(){
        return this._CeclamLegislacao;
    }
}


// WEBPACK FOOTER //
// ./src/models/ceclamCodigo.js